/*
 * WALDKAM — wk-sticky-fix.js
 * 
 * Sort le <sticky-atc> du DOM parent et le déplace en enfant direct de <body>.
 * Empêche tous les conflits de stacking context (sections custom qui passent
 * au-dessus du sticky ATC en position:fixed).
 *
 * Comme cela, le sticky n'a plus de parent autre que body et ne peut être
 * recouvert que par des éléments avec un z-index supérieur (drawers, modals).
 */
(function() {
  function moveStickyToBody() {
    var stickyElements = document.querySelectorAll('sticky-atc');
    stickyElements.forEach(function(el) {
      // Évite de déplacer 2x
      if (el.dataset.wkMoved === 'true') return;
      // Si le parent est déjà <body>, rien à faire
      if (el.parentElement === document.body) {
        el.dataset.wkMoved = 'true';
        return;
      }
      document.body.appendChild(el);
      el.dataset.wkMoved = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveStickyToBody);
  } else {
    moveStickyToBody();
  }

  // Au cas où le sticky-atc soit ajouté dynamiquement (Shopify le ré-insère parfois)
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.tagName === 'STICKY-ATC' || node.querySelector && node.querySelector('sticky-atc'))) {
          moveStickyToBody();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
